import React from "react";

const locations = [
  { name: "1954 Film\nHouse", img: "/c1.jpg" },
  { name: "Cinescape\n360", img: "/c2.jpg" },
  { name: "Cinescape\nAssima", img: "/c3.jpg" },
  { name: "Cinescape\nAvenues", img: "/c4.jpg" },
  { name: "Cinescape\nAl Kout", img: "/c5.jpg" },
  { name: "Cinescape\nKhiran", img: "/c6.jpg" },
  { name: "Cinescape\nWarehouse", img: "/c7.jpg" },
  { name: "Cinescape\nAl Fanar", img: "/c8.jpg" },
  { name: "Cinescape\nAl Muhallab", img: "/c9.jpg" },
  { name: "Cinescape\nAl Bairaq", img: "/c10.jpg" },
];

const CinescapeLocations = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-10 lg:px-16 py-12">
      <h2 className="text-3xl font-semibold mb-8">CINESCAPE LOCATIONS</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {locations.map((loc, idx) => (
          <div
            key={idx}
            className="rounded-xl overflow-hidden shadow-md bg-black cursor-pointer transition-transform duration-300"
          >
            <div className="relative w-full h-40 sm:h-48 md:h-56 lg:h-60">
              <img
                src={loc.img}
                alt={loc.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent px-4 py-3">
                <p className="text-white font-semibold whitespace-pre-line">
                  {loc.name}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CinescapeLocations;
